import { useTranslation } from 'react-i18next'

import { Alert, Card, CardTitle, Text } from '@reveni-io/reveni-ui'

import Notes from '@/parcels/components/Notes/Notes'

import ItemsToSplit from './ItemsToSplit/ItemsToSplit'
import * as Styles from './styles'

const ProductsCard = ({ lineItems = [], selectedItemsIds = [], onToggleItem, notes }) => {
  const { t } = useTranslation()

  const showingAlert = lineItems.length > 0 && selectedItemsIds.length === lineItems.length

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Partir envío')}</CardTitle>
      <Styles.MainContainer>
        <Text type="bodyMRegular">
          {t(
            'Selecciona los productos que quieres mover a un nuevo envío. Los productos no seleccionados permanecerán en el envío actual.'
          )}
        </Text>
        <ItemsToSplit lineItems={lineItems} selectedItemsIds={selectedItemsIds} onToggleItem={onToggleItem} />
        {showingAlert && (
          <Alert type="warning">
            {t('Debe quedar al menos un producto en el envío actual. Por favor, ajusta tu selección.')}
          </Alert>
        )}
        <Notes notes={notes} />
      </Styles.MainContainer>
    </Card>
  )
}

export default ProductsCard
